import { VesselSegment } from "user/userService"

export const standardVesselOptions = [
  {
    label: `Standard Handysize 38`,
    value: VesselSegment.Handysize,
  },
  {
    label: `Standard Tess 58`,
    value: VesselSegment.Supramax,
  },
  {
    label: `Standard Tess 82`,
    value: VesselSegment.Panamax,
  },
  {
    label: `Standard Capesize`,
    value: VesselSegment.Capesize,
  },
]

export function getStandardVesselDefaultValue(
  defaultSegment: VesselSegment | undefined
) {
  if (defaultSegment === VesselSegment.Capesize) {
    return standardVesselOptions[0]
  }
  if (defaultSegment === VesselSegment.Handysize) {
    return standardVesselOptions[1]
  }
  if (defaultSegment === VesselSegment.Supramax) {
    return standardVesselOptions[2]
  }
  if (defaultSegment === VesselSegment.Panamax) {
    return standardVesselOptions[3]
  }
  return standardVesselOptions[3]
}

export function getStandardVesselSpeed(segment: VesselSegment) {
  const today = new Date().toISOString().split("T")[0]
  if (segment === VesselSegment.Capesize) {
    return [
      { pos_date: today, sog: 12, laden: true },
      { pos_date: today, sog: 13, laden: false },
    ]
  }
  if (segment === VesselSegment.Supramax) {
    return [
      { pos_date: today, sog: 11, laden: true },
      { pos_date: today, sog: 11, laden: false },
    ]
  }
  if (segment === VesselSegment.Handysize) {
    return [
      { pos_date: today, sog: 12, laden: true },
      { pos_date: today, sog: 12, laden: false },
    ]
  }
  return [
    { pos_date: today, sog: 11.5, laden: true },
    { pos_date: today, sog: 12.5, laden: false },
  ]
}
